import { useEffect, useRef } from 'react';
import { presenceAPI } from '../services/api';

const HEARTBEAT_INTERVAL_MS = 30_000;

/**
 * Hook que publica la seleccion activa del agente al backend cada 30s.
 * Al cambiar de contacto, emite heartbeat con el nuevo phone.
 * Al desmontar o pasar phone=null, libera la presencia.
 * En beforeunload usa fetch keepalive (soporta headers auth, a diferencia de sendBeacon).
 */
export function useAgentPresence(selectedPhone) {
  const lastPhoneRef = useRef(null);

  useEffect(() => {
    if (!selectedPhone) {
      if (lastPhoneRef.current) {
        presenceAPI.heartbeat(null).catch(() => {});
        lastPhoneRef.current = null;
      }
      return;
    }

    lastPhoneRef.current = selectedPhone;

    // Heartbeat inmediato al cambiar de contacto
    presenceAPI.heartbeat(selectedPhone).catch(() => {});

    // Heartbeat cada 30s
    const id = setInterval(() => {
      presenceAPI.heartbeat(selectedPhone).catch(() => {});
    }, HEARTBEAT_INTERVAL_MS);

    // beforeunload: fetch keepalive (sobrevive al cierre de pestana)
    const onUnload = () => {
      try {
        // [F2] Sesion por cookie httpOnly (viaja sola, incluso con keepalive)
        const baseUrl = '/api/crm-web';
        fetch(`${baseUrl}/presence/release`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({}),
          keepalive: true
        }).catch(() => {});
      } catch (_) {}
    };
    window.addEventListener('beforeunload', onUnload);

    return () => {
      clearInterval(id);
      window.removeEventListener('beforeunload', onUnload);
    };
  }, [selectedPhone]);

  // Cleanup al desmontar el componente completamente (cambio de vista)
  useEffect(() => {
    return () => {
      presenceAPI.heartbeat(null).catch(() => {});
    };
  }, []);
}
